export class MessageType {
  id: number = null;
  description: string = null;
  displayInXselleratorUIFlag: boolean = null;

  constructor(obj?: MessageType) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
